export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "package_groups_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets disponibles"])},
          "packages_from_stock_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques en Stock"])},
          "total_package_groups": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " pallets"])},
          "total_packages_from_stock": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " empaques"])},
          "new_package_group_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo Pallet"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])}
        }
      }
    }
  })
}